export const getCampaignStyles = (components, theme) => ({
  '@global': {
    '& .app-content-container-col .default-layout': {
      'overflow-y': 'hidden',
    },
  },
  stepContainer: {
    '& .collapse-panel': {
      width: 900,
    },
  },
  bidStrategy: {
    marginTop: 20,
    marginBottom: 20,
  },
  bidStrategyTitle: {
    fontWeight: 600,
    marginBottom: 8,
  },
  divider: {
    padding: '5px 0px 0px 4px',
    width: '100%',
    borderTop: '2px solid #E0E0E0',
    marginTop: 30,
    marginBottom: 20,
  },
  budgetContainer: {
    '& .budget-title-container span': {
      fontWeight: 600,
    },
  },
  campaignShell: {
    display: 'flex',
    width: 966,
  },
  collapsiblePanel: {
    border: 'none',
    marginBottom: 'unset',
    backgroundColor: 'unset',

    '& .panel-heading': {
      padding: 0,
      borderBottom: 'none',
      marginBottom: 18,

      '& .panel-title': {
        fontSize: 18,
        '& > a': {
          color: theme.palette.themePrimary,
          padding: 0,
          '&:hover, &:active': {
            color: theme.palette.themeDarker,
            textDecoration: 'none',
            backgroundColor: 'unset',
          },
        },

        '& > a:after': {
          transform: 'rotate(180deg)',
        },

        '& > a.collapsed:after': {
          transform: 'rotate(90deg)',
        },
      },
    },

    '& .panel-collapse': {
      '& .panel-body': {
        padding: 0,
        overflow: 'hidden',
      },
    },
  },
});
